import React, { FC, memo, useEffect, useRef, useState } from "react";
import { TableSessionStatus, UserPlan } from "../constants/enum";
import { colors, queryKeys } from "../constants/constans";

import Cookies from "js-cookie";
import CustomNotification from "./CustomNotification";
import ModalConfirm from "./Modal/ModalConfirm";
import { StaffType } from "../types/StaffType";
import { TimeLineType } from "../types/TimeLineType";
import classNames from "classnames";
import { displayStaffName } from "utils/helper/common";
import moment from "moment";
import styles from "./styles.module.scss";
import { useCalcEndTime } from "../hooks/useCalcEndTime";
import useDragStaff from "../hooks/useDragStaff";
import useInRandom from "../hooks/useInRandom";
import { useQuery } from "react-query";
import useSetOrderList from "../hooks/useSetOrderList";
import useSetTimeLineInfo from "../hooks/useTimeLineInfo";

export const TimeLine: FC<TimeLineType> = (props: TimeLineType) => {
  const {
    startTime,
    intervalTime,
    courseTime,
    timer,
    countNextBtn,
    infoTable,
    setTimelineData,
    cls,
    formListTable,
    activeTableId,
    fromHistory,
  } = props;

  const { calcNextTime } = useCalcEndTime();
  const { timeLineInfo, setTimeLineInfo } = useSetTimeLineInfo();
  const { staff, setStaffDrag } = useDragStaff();
  const { orderList } = useSetOrderList();
  const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
  const blockCurrent = useRef<number>(-1);
  const indexCurrent = useRef<number>(-1);
  const { setInRandom } = useInRandom();
  const userPlan = Cookies.get("userPlan");

  const { data: listTimeWorkStaff } = useQuery(
    queryKeys.listTimeWorkStaff
  ) as any;

  //startTime
  const [timeLineData, setTimeLineData] = useState<string[]>([startTime]);

  const oldTimeLineDataRef = useRef<Array<string>>([startTime]); //前回までのTimeLineData

  //前回のタイムラインデータを所得
  let defaultTimeLineData = [...timeLineData];
  let revisionTimeLineData = [...oldTimeLineDataRef.current];

  useEffect(() => {
    // const newTimeLineInfo = timeLineInfo.map((item: any) => {
    //   const realTimeStart = timeLineData?.findIndex(
    //     (_, index) => index === item?.block
    //   );
    //   if (realTimeStart !== -1) {
    //     const startTime = timeLineData?.[realTimeStart];
    //     const endTime = timeLineData?.[realTimeStart + 1];
    //     return {
    //       ...item,
    //       startTime,
    //       endTime,
    //     };
    //   }
    // });
    // console.log("newTimeLineInfo", newTimeLineInfo);
    // setTimeLineInfo(newTimeLineInfo);
  }, [timeLineData]);

  //スタート時間と着席時間、ロスタイムから時間の区切りを作成
  const createTimeLineData = (
    startTime: string,
    intervalTime: number,
    timer: number
  ) => {
    let divisionNum = Math.ceil(
      courseTime / (Number(timer) + Number(intervalTime))
    );
    //初回のみ基本タイムラインデータ作成
    defaultTimeLineData = [startTime];

    for (let i = 0; i < divisionNum + 6; i++) {
      let nextTime = calcNextTime(startTime, intervalTime, timer);
      defaultTimeLineData = [...defaultTimeLineData, nextTime];
      startTime = nextTime;
    }
    oldTimeLineDataRef.current = [...defaultTimeLineData];
    revisionTimeLineData = [...defaultTimeLineData];

    setTimeLineData(defaultTimeLineData);
    if (setTimelineData) {
      setTimelineData(defaultTimeLineData);
    }

    oldTimeLineDataRef.current = [...revisionTimeLineData];
  };

  //--------ここからドラッグされたときの挙動--------//
  const dragStart = (staff: StaffType, block?: number) => {
    if (block && block < (infoTable as any)?.step) {
      return;
    }
    setStaffDrag({ ...staff, isFromTimeLine: true });
  };

  const dragEnd = (e: React.DragEvent<HTMLDivElement>) => {};

  //ドラッグエリアに入ったらどうするか
  const onDragEnter = (e: React.DragEvent<HTMLDivElement>) => {};

  //ドラッグされた場所で何をするか
  const onDropTineLine = (block: number, index: number) => {
    if (Number(userPlan) === UserPlan.SubAccount) {
      return;
    }
    if (!!formListTable && activeTableId !== (infoTable as any)?._id) {
      return;
    }
    if (!!infoTable) {
      if (block < (infoTable as any)?.step && !fromHistory) {
        CustomNotification({
          type: "error",
          description: "過去の枠にはスタッフが追加できません",
          message: "",
        });
        return;
      }
    }

    let startTimeOfBlock = moment(startTime, "HH:mm")
      .add((Number(intervalTime) + Number(timer)) * block, "m")
      .format("HH:mm");
    let entTimeOfBlock = moment(startTime, "HH:mm")
      .add((Number(intervalTime) + Number(timer)) * (block + 1), "m")
      .format("HH:mm");

    if (!staff) return;

    const existStaff = timeLineInfo?.find(
      (item: any) => item?.id === staff?.id && !staff?.isFromTimeLine
    );
    const existStaffInBlock = timeLineInfo?.find(
      (item: any) =>
        item?.id === staff?.id && item?.block === block && item?.index === index
    );

    const existStaffInIndex = timeLineInfo?.find(
      (item: any) => item?.block === block && item?.index === index
    );
    const changeIndexStaff = staff?.block === block;

    if (!!existStaffInIndex && !changeIndexStaff) {
      CustomNotification({
        type: "error",
        description: "既にスタッフが設定されています。",
        message: "",
      });
      return;
    }

    if (!!existStaffInIndex && changeIndexStaff) {
      const timeLineInfoNew = [] as any[];
      timeLineInfo.forEach((item: any) => {
        if (item?.block === block && item?.index === staff?.index) {
          timeLineInfoNew.push({
            ...item,
            index: existStaffInIndex?.index,
          });
        } else if (
          item?.block === block &&
          item?.index === existStaffInIndex?.index
        ) {
          timeLineInfoNew.push({
            ...item,
            index: staff?.index,
          });
        } else {
          timeLineInfoNew.push({
            ...item,
          });
        }
      });

      setTimeLineInfo([...timeLineInfoNew]);
      setStaffDrag(null);
      return;
    }
    if (!!existStaffInBlock) {
      return;
    }
    if (!!existStaff) {
      setShowModalConfirm(true);
      blockCurrent.current = block;
      indexCurrent.current = index;
      return;
    }
    const listStaffInBlock = timeLineInfo?.filter(
      (item: StaffType) => item?.block === block
    );

    const timeLineInfoNew = timeLineInfo?.filter(
      (item: StaffType) =>
        !(
          item.block === staff?.block &&
          item?.index === staff?.index &&
          item?.id === staff?.id
        )
    );
    setTimeLineInfo([
      ...timeLineInfoNew,
      {
        ...staff,
        block: block,
        startTime: startTimeOfBlock,
        endTime: entTimeOfBlock,
        index: index, //index start 0 :D, but index in timeline start 1
      },
    ]);
    setInRandom(false);
    setStaffDrag(null);
  };

  const getStaffInBlock = (block: number) => {
    const listStaff = timeLineInfo?.filter(
      (item: any) => item?.block === block
    );
    return listStaff;
  };

  const handleGetBackground = (id: string) => {
    const staffInList = orderList?.filter(
      (item: any) => String(item?.staff?.id) === String(id)
    );

    const listIndex = staffInList?.map((item: any) => Number(item?.index));

    const colorsOfStaff = colors.filter((_, index) =>
      listIndex?.includes(Number(index))
    );
    if (colorsOfStaff.length < 1) {
      return "";
    }
    if (colorsOfStaff.length === 1) {
      return colorsOfStaff?.[0];
    }

    const colorPercent = 100 / colorsOfStaff.length;

    let result = `linear-gradient(to right,`;

    colorsOfStaff.forEach((color, index) => {
      result += color + " " + colorPercent * index + "%,";
      result += color + " " + colorPercent * (index + 1) + "%";

      if (index !== colorsOfStaff.length - 1) {
        result += ",";
      }
    });
    return result;
  };

  const checkStaffWillDuplicate = (staffId: string, block: number) => {
    if (
      listTimeWorkStaff &&
      listTimeWorkStaff?.data &&
      !Object.keys(listTimeWorkStaff?.data).includes(staffId)
    )
      return;
    const listTimeWork = listTimeWorkStaff?.data[staffId];
    const infoCurrent = timeLineInfo?.find(
      (item: any) => item?.block === block && item?.id === staffId
    );
    let isDuplicate = false;

    let dateReal = (infoTable as any)?.dateReal;
    if (!infoTable) {
      if (
        Math.abs(moment(startTime, "HH:mm").diff(moment(), "s")) >=
        12 * 60 * 60
      ) {
        if (moment(startTime, "HH:mm").isAfter(moment())) {
          dateReal = moment()
            .set({
              hour: moment(startTime, "HH:mm").hour(),
              minute: moment(startTime, "HH:mm").minute(),
              second: 0,
            })

            .subtract(1, "day")
            .toISOString();
        } else {
          dateReal = moment()
            .set({
              hour: moment(startTime, "HH:mm").hour(),
              minute: moment(startTime, "HH:mm").minute(),
              second: 0,
            })

            .add(1, "day")
            .toISOString();
        }
      }
    }
    listTimeWork?.forEach((item: any) => {
      const startTime1 =
        item?.infoSession?.timeLineInfoReal?.find(
          (_: any, index: number) => index === Number(item?.block)
        ) || "";
      const startTime2 =
        timeLineData?.find(
          (_: any, index: number) => index === Number(infoCurrent?.block)
        ) || "";
      const endTime1 =
        item?.infoSession?.timeLineInfoReal?.find(
          (_: any, index: number) => index === item?.block + 1
        ) || "";
      const endTime2 =
        timeLineData?.find(
          (_: any, index: number) => index === infoCurrent?.block + 1
        ) || "";

      const combinedTime1 = moment(item?.infoSession?.dateReal).set({
        hour: parseInt(endTime1?.split(":")[0], 10),
        minute: parseInt(endTime1?.split(":")[1], 10),
        second: 0,
        millisecond: 0,
      });
      const combinedTime2 = moment(dateReal).set({
        hour: parseInt(endTime2?.split(":")[0], 10),
        minute: parseInt(endTime2?.split(":")[1], 10),
        second: 0,
        millisecond: 0,
      });

      const combinedTime3 = moment(item?.infoSession?.dateReal).set({
        hour: parseInt(startTime1?.split(":")[0], 10),
        minute: parseInt(startTime1?.split(":")[1], 10),
        second: 0,
        millisecond: 0,
      });
      const combinedTime4 = moment(dateReal).set({
        hour: parseInt(startTime2?.split(":")[0], 10),
        minute: parseInt(startTime2?.split(":")[1], 10),
        second: 0,
        millisecond: 0,
      });

      if (toMinutes(item.endTime) < toMinutes(item.infoTable?.startTime)) {
        combinedTime1.add(1, "day");
      }

      if (
        toMinutes(infoCurrent.endTime) <
        toMinutes((infoTable as any)?.tableConfig?.startTime || startTime)
      ) {
        combinedTime2.add(1, "day");
      }

      if (toMinutes(item.startTime) < toMinutes(item.infoTable?.startTime)) {
        combinedTime3.add(1, "day");
      }

      if (
        toMinutes(infoCurrent.startTime) <
        toMinutes((infoTable as any)?.tableConfig?.startTime || startTime)
      ) {
        combinedTime4.add(1, "day");
      }

      if (
        (combinedTime1.isBetween(combinedTime4, combinedTime2, null, "()") ||
          combinedTime3.isBetween(combinedTime4, combinedTime2, null, "()") ||
          combinedTime4.isBetween(combinedTime3, combinedTime1, null, "()") ||
          combinedTime2.isBetween(combinedTime3, combinedTime1, null, "()") ||
          (combinedTime4.isSame(combinedTime3) &&
            combinedTime1.isSame(combinedTime2))) &&
        item.infoSession?._id !==
          (infoCurrent.infoSession?._id || (infoTable as any)?._id) &&
        combinedTime2.isAfter(moment()) &&
        combinedTime1.isAfter(moment())
      ) {
        isDuplicate = true;
      }
    });

    return isDuplicate;
  };

  const toMinutes = (timeString: string) => {
    const time = moment(timeString, "HH:mm");
    return time.get("hour") * 60 + time.get("minute");
  };
  const renderTimeLine = () => {
    //分割の数
    const totalTime =
      Number(courseTime) +
      (Number((infoTable as any)?.totalDifferentTime) || 0) / 60;

    let divisionNum = Math.ceil(
      totalTime / (Number(timer) + Number(intervalTime))
    );

    const totalTIme =
      infoTable && Array.isArray((infoTable as any)?.timeLineInfoReal)
        ? (infoTable as any)?.timeLineInfoReal?.length
        : divisionNum + 6;
    let item = [] as any[];
    for (let i = 0; i < divisionNum; i++) {
      item.push(
        <tr data-timelineindex={i} className={countNextBtn === i ? "now" : ""}>
          <th>{revisionTimeLineData[i]}</th>
          <td>
            <ul>
              {[0, 1, 2, 3].map((item) => {
                return (
                  <div
                    className="blockTimeLine"
                    onDragEnd={dragEnd}
                    onDragEnter={onDragEnter}
                    onDragOver={(e) => {
                      e.preventDefault(); // これがないとdropイベントが発火しない
                    }}
                    onDrop={() => onDropTineLine(i, item)}
                  >
                    {getStaffInBlock(i)
                      ?.filter((staff: any) => staff?.index === item)
                      ?.map((item: any, index: number) => (
                        <li
                          draggable={true}
                          onDragStart={() => dragStart(item, i)}
                          key={index}
                          style={{ background: handleGetBackground(item?.id) }}
                          className={styles.staffTimeLine}
                        >
                          <div className="staff">
                            {displayStaffName(item?.staffName)}
                          </div>
                          {checkStaffWillDuplicate(item?.id, i) && (
                            <div className={styles.warningDuplicate}>!</div>
                          )}
                        </li>
                      ))}
                  </div>
                );
              })}
            </ul>
          </td>
        </tr>
      );
    }
    for (let i = divisionNum; i < totalTIme; i++) {
      item.push(
        <tr
          data-timelineindex={i}
          className={countNextBtn === i ? "now white" : "white"}
        >
          <th>{revisionTimeLineData[i]}</th>
          <td>
            <ul>
              {[0, 1, 2, 3].map((item) => {
                return (
                  <div
                    className="blockTimeLine"
                    onDragEnd={dragEnd}
                    onDragEnter={onDragEnter}
                    onDragOver={(e) => {
                      e.preventDefault(); // これがないとdropイベントが発火しない
                    }}
                    onDrop={() => onDropTineLine(i, item)}
                  >
                    {getStaffInBlock(i)
                      ?.filter((staff: any) => staff?.index === item)
                      ?.map((item: any, index: number) => (
                        <li
                          draggable={true}
                          onDragStart={() => dragStart(item, i)}
                          key={index}
                          style={{ background: handleGetBackground(item?.id) }}
                          className={styles.staffTimeLine}
                        >
                          <div className="staff">
                            {displayStaffName(item?.staffName)}
                          </div>
                          {checkStaffWillDuplicate(item?.id, i) && (
                            <div className={styles.warningDuplicate}>!</div>
                          )}
                        </li>
                      ))}
                  </div>
                );
              })}
            </ul>
          </td>
        </tr>
      );
    }
    return item;
  };

  useEffect(() => {
    if (!!infoTable) {
      setTimeLineData((infoTable as any)?.timeLineInfoReal);
      revisionTimeLineData = [...(infoTable as any)?.timeLineInfoReal];
      oldTimeLineDataRef.current = [...(infoTable as any)?.timeLineInfoReal];
    } else {
      createTimeLineData(startTime, intervalTime, timer);
    }
  }, [courseTime, timer, countNextBtn, intervalTime, infoTable]);

  useEffect(() => {
    if (!infoTable) {
      setTimeLineInfo([]);
    } else {
      setTimeLineInfo((infoTable as any)?.timeLineInfo);
    }
  }, [infoTable]);

  useEffect(() => {
    if (startTime !== (infoTable as any)?.tableConfig?.startTime) {
      createTimeLineData(startTime, intervalTime, timer);
    }
  }, [startTime]);

  const handleCloseModalConfirm = () => {
    setShowModalConfirm(false);
  };

  const handleAddStaffDuplicate = () => {
    let startTimeOfBlock = moment(startTime, "HH:mm")
      .add((Number(intervalTime) + Number(timer)) * blockCurrent.current, "m")
      .format("HH:mm");
    let entTimeOfBlock = moment(startTime, "HH:mm")
      .add(
        (Number(intervalTime) + Number(timer)) * (blockCurrent.current + 1),
        "m"
      )
      .format("HH:mm");

    const listStaffInBlock = timeLineInfo?.filter(
      (item: StaffType) => item.block === blockCurrent.current
    );
    const timeLineInfoNew = timeLineInfo?.filter(
      (item: StaffType) =>
        !(
          item.block === staff?.block &&
          item?.index === staff?.index &&
          item?.id === staff?.id
        )
    );
    setTimeLineInfo([
      ...timeLineInfoNew,
      {
        ...staff,
        block: blockCurrent.current,
        startTime: startTimeOfBlock,
        endTime: entTimeOfBlock,
        index: indexCurrent.current, //index start 0 :D, but index in timeline
      },
    ]);
    setStaffDrag(null);
    setShowModalConfirm(false);
  };

  return (
    <>
      <ModalConfirm
        title="既にスタッフは追加されていますが追加しますか？"
        textCancel={"いいえ"}
        textOke={"はい"}
        header="確認"
        isVisible={showModalConfirm}
        closeIcon={false}
        handleOke={handleAddStaffDuplicate}
        handleCancel={handleCloseModalConfirm}
        handleClose={handleCloseModalConfirm}
      />
      <div className={classNames("timeLine", { [cls]: !!cls })}>
        <div className="indexTimeline">
          <div>4</div>
          <div>3</div>
          <div>2</div>
          <div>1</div>
        </div>
        <table>
          <tbody>{renderTimeLine()}</tbody>
        </table>
      </div>
    </>
  );
};
